import { $features } from '@/entities/features-entity';
import { senderRoutes } from '@/lib/sender-routes';
import SenderNavRow from '@/pages/sender/components/sender-nav-row';
import { SenderScreen } from '@/pages/sender/sender-screen';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router';

export default function SenderMorePage() {
	const navigate = useNavigate();
	const { senderHubProfileSettingsVisible, senderHubAuthJobsVisible } = useUnit($features);

	const rows = [
		{ label: 'Сценарии', to: senderRoutes.scenarios },
		{ label: 'Ход рассылки', to: senderRoutes.console, from: senderRoutes.more },
		{ label: 'Статистика', to: senderRoutes.stats },
		...(senderHubProfileSettingsVisible
			? [{ label: 'Настройки лендинга', to: senderRoutes.settings }]
			: []),
		...(senderHubAuthJobsVisible ? [{ label: 'Входы с лендинга', to: senderRoutes.authJobs }] : []),
	];

	return (
		<SenderScreen title='Ещё'>
			<div className='flex flex-col gap-2'>
				{rows.map(row => (
					<SenderNavRow
						key={row.label}
						label={row.label}
						onClick={() =>
							navigate(row.to, 'from' in row && row.from ? { state: { from: row.from } } : undefined)
						}
					/>
				))}
			</div>
		</SenderScreen>
	);
}
